<template>
	<div class="service-picker-mobile-container">
		<smooth-picker :data="setServiceOptions" :change="handleServiceChange"/>
		<BaseButton title="Choose"
			:classNames="['button--modifier']"
			@click.prevent="handleChoose"/>
	</div>
</template>

<script>
	import EventBus from '@EventBus';
	import serviceMixin from '@Mixin/serviceMixin';
	import pickerMixin from '@Mixin/pickerMixin';
	import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
	import { findIndex, map } from 'lodash';

	export default {
		mixins: [
			serviceMixin,
			pickerMixin,
		],
		data() {
			return {
				services: [],
			};
		},
		computed: {
			setServiceOptions() {
				this.refreshServices();
				const serviceType = this.getServiceType;
				const currentService = this.getServiceIndex(serviceType);
				return [
					{
						currentIndex: currentService,
						flex: 1,
						list: this.services,
						textAlign: 'center',
						className: 'row-group',
					},
				]
			},
		},
		methods: {
			refreshServices() {
				this.services = map(this.getServiceMap(), 'name');
			},
			getServiceIndex(data) {
				const resolveName = this.resolveServiceName;
				// find index of current service
				const index = findIndex(this.services, (serviceName) => {
					return serviceName === resolveName(data);
				});
				return index;
			},
			getServiceMap() {
				let services = [{
					value: EServiceType.SERVICE_TYPE_TAKEOUT,
					name: 'Pickup',
				}];
				if (this.service_isDeliveryEnabled) {
					services.push({
						value: EServiceType.SERVICE_TYPE_DELIVERY,
						name: 'Delivery',
					});
				}
				/* TODO create more dynamic actions based on layoutOptions
				* or a services object inside of the main application configuration
				*/
				// services.push({
				// 	value: EServiceType.SERVICE_TYPE_SEATED,
				// 	name: 'Dine-in',
				// });
				return services;
			},
			handleServiceChange(groupIndex, itemIndex) {
				const serviceMap = map(this.getServiceMap(), 'value');
				const selectedService = serviceMap[itemIndex];
				this.setServiceType(selectedService);
				EventBus.$emit('service-type-updated');
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.smooth-picker {
		font-size: 32px;
	}
	@include phone {
		.smooth-picker {
			font-size: 5vw;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseServicePickerMobile.vue